import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/science/')({
  beforeLoad: () => {
    throw redirect({ to: '/classic-guide/$pageId', params: { pageId: 'science' } });
  },
});
